import styled from 'styled-components';

export const Container = styled.div`
    
    display: flex;
    flex-direction: column;
    border: 1px solid transparent;
    align-items: stretch;

    .div-text-card-tutorial {
        color: #3a3b3c;
        margin-bottom: 1rem;
        display: flex;
        flex-direction: column;
        font-family: Poppins;
        width: fit-content;
        height: 40%;

        span {
            color: #3a3b3c;
            font-size: 1.2em;
            font-weight: 500;
        }

        ul {
            li {
                color: #3a3b3c;
                font-size: 1.0em;
                font-weight: 300;
            }
        }
    }

    
    img {
        width: 100%;
        height: 13rem;
        object-fit: cover;
        object-position: center;
        border-radius: 10px;
        border: 0.5px solid #c4c4c4;
        border-radius: 10px;
    }
    
`;
